<template>
   
  <div class="col-md-12 mb-4">
    <div class="card ai-magic-card border-0 shadow-lg overflow-hidden position-relative">
      <div class="card-body p-5">
        <div class="row align-items-center position-relative" style="z-index: 2;">
          <div class="col-md-8">
            <div class="badge bg-white bg-opacity-25 text-dark px-3 py-2 rounded-pill mb-3 small fw-bold text-uppercase tracking-wider">
              <i class="fas fa-sparkles me-1"></i> Beta Feature
            </div>
            <h2 class="fw-extrabold mb-3 text-white display-6">
              AI Strategy Hub
            </h2>
            <p class="mb-4 text-white text-opacity-90 fs-5 fw-light lh-base">
              Elevate your productivity. Let our AI analyze your workflow, 
              break down complex tasks, and optimize your project timeline instantly.
            </p>
            <button @click="$router.push('/ai-assistant')" 
                    class="btn btn-glass px-5 py-3 rounded-pill fw-bold transition-all shadow-sm">
              Launch AI Assistant <i class="fas fa-bolt ms-2"></i>
            </button>
          </div>
        </div>

        <div class="decoration-circle"></div>
        <i class="fas fa-robot ai-bg-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiAssistanceCard",
};
</script>

<style scoped>
/* Main Gradient and Background */
.ai-magic-card {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #db2777 100%);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  min-height: 320px;
}

.ai-magic-card:hover {
  transform: translateY(-8px);
}

/* Glassmorphism Button */
.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white !important;
}

.btn-glass:hover {
  background: white !important;
  color: #4f46e5 !important;
  transform: scale(1.05);
}

/* Background Robot Icon */
.ai-bg-icon {
  position: absolute;
  right: -20px;
  bottom: -20px;
  font-size: 240px;
  color: white;
  opacity: 0.1;
  transform: rotate(-15deg);
  pointer-events: none;
}

/* Decorative Circle */
.decoration-circle {
  position: absolute;
  top: -50px;
  left: -50px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  pointer-events: none;
}

.fw-extrabold { font-weight: 800; }
.tracking-wider { letter-spacing: 1px; }
.transition-all { transition: all 0.3s ease; }
</style>
 